<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">
      <div class="web-order-state">
        <h2>
          <p>订单编号：{{order_info.erp_order_no!='' ? order_info.erp_order_no : order_info.order_no}} <b>({{order_info.ctime}})</b> </p>
          <a>待评价</a>
        </h2>
      </div>

      <div class="web-order-main">

        <div class="web-order-address">
            <h2>餐厅名称：{{order_info.store_name}}</h2>
            <ul>
                <li v-if="order_info.market_name">
                    <p>所属市场：{{order_info.market_name}}</p>
                </li>
                <li v-if="order_info.store_no">
                    <p>门店编号：{{order_info.store_no}}</p>
                </li>
                <li v-if="order_info.zoneNo">
                    <p>国际编码：{{order_info.zoneNo}}</p>
                </li>
                <li v-if="order_info.market_name">
                    <p>餐厅电话：{{order_info.store_phone}}</p>
                </li>
                <li v-if="order_info.user_phone">
                    <p>联系电话：{{order_info.user_phone}}</p>
                </li>
                <li v-if="order_info.store_address">
                    <p>餐厅地址：{{order_info.store_address}}</p>
                </li>
            </ul>
        </div>
        <div class="web-order-address-line"></div>

        <div class="web-order-info-title" style="border:0px;">
            <h2>商品清单</h2>
        </div>

        <div class="web-order-goods-box">

            <div v-for="(vo,index) in goods_list" :key="index" class="web-cart-list-data">
                <div class="web-cart-list-checkbox">
                    <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                </div>
                <div class="web-cart-list-goods">
                    <p>{{vo.goods_name}}</p>
                    <a>{{vo.goods_no}}</a>
                </div>
                <div class="web-cart-list-props"></div>
                <div class="web-cart-list-price">
                  <h2>商品评价</h2>
                  <p>
                    <img @click="set_evaluate_level(1,index)" :src="[ vo.evaluate_level>=1 ? xx_ok : xx_no ]"/>
                    <img @click="set_evaluate_level(2,index)" :src="[ vo.evaluate_level>=2 ? xx_ok : xx_no ]"/>
                    <img @click="set_evaluate_level(3,index)" :src="[ vo.evaluate_level>=3 ? xx_ok : xx_no ]"/>
                    <img @click="set_evaluate_level(4,index)" :src="[ vo.evaluate_level>=4 ? xx_ok : xx_no ]"/>
                    <img @click="set_evaluate_level(5,index)" :src="[ vo.evaluate_level==5 ? xx_ok : xx_no ]"/>
                  </p>
                </div>
                <div class="web-cart-list-quantity">
                  <p>
                    <b-form-textarea
                        placeholder="请描述商品评价，可以帮助更多想买的人"
                        rows="3"
                        max-rows="3"
                        maxlength="100"
                        :value="vo.evaluate_remark"
                        data-index={index}
                        v-model="vo.evaluate_remark"
                    ></b-form-textarea>
                  </p>
                </div>
            </div>

        </div>

      </div>

      <div class="web-order-footer">
        <h2>
            <a @click="post_data()" class="red">确认评价</a>
        </h2>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import Toast from '@/components/toast/index'

export default {
  name: 'order_evaluate',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '订单详情',
      web_url: webUrl(),
      pay_win_state: 0,
      header_title: '',
      xx_ok: require('@/assets/icon/xx_1.png'),
      xx_no: require('@/assets/icon/xx_2.png'),
      order_no: '',
      delivery_way: '',
      order_info: {},
      goods_list: [],
      post_state: false,
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    var params = this.$route.query
    var orderNo = Decrypt(params.v)

    this.load_data(orderNo)
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    set_evaluate_level (level, index) {
      var that = this
      setTimeout(function () {
        that.goods_list[index].evaluate_level = level
        that.post_state = true
      }, 300)
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    },
    post_data () {
      var goodsList = this.goods_list
      var that = this

      console.log({
        uid: getUserId(),
        order_no: that.order_no,
        goods_list: JSON.stringify(goodsList)
      })

      ajax({
        url: '/store/order/add_goods_evealuate',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: that.order_no,
          goods_list: JSON.stringify(goodsList)
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
          setTimeout(function () {
            that.$router.push({path: '/order/order_show', query: {v: Encrypt(that.order_no)}})
          }, 1500)
        } else {
          that.toast(ret.msg)
        }
      })
    },
    load_data (orderNo) {
      var that = this
      ajax({
        url: '/store/order/order_show',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.header_title = ret.data.order_info.order_state_name
          that.order_info = ret.data.order_info
          that.order_no = ret.data.order_info.order_no

          var list = ret.data.goods_list
          var goodsList = []

          list.forEach(function (val) {
            goodsList.push({
              goods_no: val.goods_no,
              goods_name: val.goods_name,
              goods_image: val.goods_image,
              evaluate_level: '5',
              evaluate_state: '0',
              evaluate_remark: ''
            })
          })

          that.goods_list = goodsList
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-state { width:100%; height:50px; margin-top:15px;border-left:3px solid #d81e06;}
    .web-order-state h2 { width:100%; height:50px;  margin:0px;line-height:50px; justify-content:space-between; padding:0px 20px; border:1px solid #dfdfdf;color:#333333;}
    .web-order-state p { width:auto; height:50px; margin:0px; font-weight: bold; padding:0px; line-height:50px; font-size:14px; color:#333333; }
    .web-order-state p b { font-weight: normal; font-size:12px;}
    .web-order-state a { width:auto; height:50px; line-height:50px;  font-size:12px; color:#333333;}
    .web-order-state a:hover { color:#333333;}

.web-order-main { width:100%; height:auto; padding:20px; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-address ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-address ul li { width:50%; height:30px; margin:0px; padding:0px;}
    .web-order-address ul li p { width:100%; height:30px; margin:0px; padding:0px; line-height:30px; font-size:12px; color:#333333;}
    .web-order-address-line { width:100%; height:5px; margin-top:15px; background-size: auto 100%; background-image:url('../../assets/icon/order_address_line.png'); background-repeat : repeat-x;}

.web-order-info-title { width:100%; height:auto; margin-top:10px; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-title h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-title p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-title p div.custom-radio { cursor: pointer;}
    .web-order-info-title h2 span { font-size:12px; color:#666666; font-weight: normal; margin-left:20px;}

    .web-order-info-integral { width:100%; height: 50px; margin-top:10px;}
        .web-order-info-integral-input { width:200px; height: 30px; border:1px solid #dfdfdf;}
            .web-order-info-integral-input input { width:190px; height:20px; border:0px; margin-top:5px; line-height:20px; font-size:12px; padding:0px 15px;}
        .web-order-info-integral-button { width:100px; height:30px; border:1px solid #d81e06; margin-left:10px;}
            .web-order-info-integral-button p { width:100px; cursor: pointer; height:30px;  text-align: center; line-height: 30px; justify-content:center; font-size:12px; color:#d81e06;}
  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}
 .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:12px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:12px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:140px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-props p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-price {width:120px; height:auto; line-height:80px; margin-top:20px; flex-wrap:wrap; align-content:flex-start; font-size:12px; color:#333333;}
  .web-cart-list-price h2 { width:100%; height:30px; line-height:30px; font-size:12px; color:#333333; }
  .web-cart-list-price p { width:100%; height:30px; flex-flow:row; justify-content:flex-start; }
  .web-cart-list-price p img { width:20px; height:20px; margin:0px 5px 0px 0px; cursor: pointer; }

  .web-cart-list-quantity { width:350px; height:auto; text-align: center; justify-content:flex-end; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-quantity p { width:300px; height:60px; margin-top:20px; border:1px solid #dfdfdf;}
  .web-cart-list-quantity p textarea { width:100%; height:58px; font-size:12px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:120px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:12px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox { width:110px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 15px;}

  .web-order-goods-box { width:100%; height:auto; margin-top:10px; border-top:1px solid #dfdfef; flex-wrap:wrap; align-content:flex-start;}

.web-order-footer { width:100%; height:auto; flex-wrap:wrap; margin-top:15px;  align-content:flex-start;}
    .web-order-footer ul { width:100%; height:auto; margin:0px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul.money {  height:90px; background: #f4f4f4; padding-top:15px; border-top:1px solid #dfdfdf;}
    .web-order-footer ul li { width:100%; height:30px;margin:0px; padding:0px; justify-content:flex-end;}
    .web-order-footer ul li p { width:70px; height:30px;margin:0px; padding:0px; line-height:30px; color:#333333; font-size:12px;}
    .web-order-footer ul li a { min-width:120px; height:30px; line-height:30px; color:#333333; font-size:12px; text-align: right; justify-content:flex-end;}
    .web-order-footer ul li a:hover { color:#333333;}
    .web-order-footer ul li a span { color:#999999; margin-left:5px;}
    .web-order-footer ul li a span.select { color:#E6A23C;}
    .web-order-footer ul li a.red { color:#d81e06; font-size:18px; font-weight: bold;}
    .web-order-footer h2 { width:100%; height:50px; margin-top:15px; justify-content:flex-end;}
    .web-order-footer h2 a {width:150px; height:40px; margin-left:15px; cursor: pointer;border: 1px solid #dfdfdf; line-height:40px; border-radius: 4px; text-align: center; justify-content:center; background: #ffffff; font-size:14px; color:#333333;}
    .web-order-footer h2 a:hover { color:#333333;}
    .web-order-footer h2 a.red { color:#ffffff; background: #d81e06;border: 1px solid #d81e06;}
    .web-order-footer h2 a.red:hover { color:#ffffff;}

#textarea { font-size:12px;}

</style>



// WEBPACK FOOTER //
// src/pages/order/order_evaluate.vue